module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BookartNumber"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.internal),
      expression: "internal",
      modifiers: {
        "number": true
      }
    }],
    style: ({
      width: _vm.width
    }),
    attrs: {
      "type": "number",
      "step": _vm.step,
      "min": _vm.min,
      "max": _vm.max
    },
    domProps: {
      "value": (_vm.internal)
    },
    on: {
      "blur": [_vm.onBlur, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.internal = _vm._n($event.target.value)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79feec0f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookartQuantities/BookartNumber.vue
// module id = 193
// module chunks = 2